import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ChatbotApp from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChatbotApp />
  </React.StrictMode>
);